/* eslint-disable react/prop-types */
import React from 'react';

import './index.css';

const Header = ({ children }) => {
  return <div className="CardOld__header">{children}</div>;
};

const Body = ({ children }) => {
  return <div className="CardOld__body">{children}</div>;
};

const Icon = ({ children }) => {
  return <div className="CardOld__icon">{children}</div>;
};

const Card = ({ children }) => {
  return <div className="CardOld">{children}</div>;
};

Card.Header = Header;
Card.Body = Body;
Card.Icon = Icon;

export default Card;



// WEBPACK FOOTER //
// ../ui-components/components/CardOld/index.jsx